import { useQuery } from '@apollo/client';
import type { ImportFile } from '@interfaces/bulkImport';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { FETCH_IMPORT_FILE_BREADCRUMB } from './importFileBreadcrumb.query';

export const ImportFileBreadcrumb = () => {
  const { data } = useQuery(FETCH_IMPORT_FILE_BREADCRUMB, {
    variables: { importFileId: useParams().importFileId },
  });
  const { t } = useTranslation();
  const importFile: ImportFile = data?.fetchImportFile?.importFile;

  return data
    ? `${t(`bulkImport:fileTypes.${importFile.type}`)} - ${importFile.fileDocument?.name}`
    : '';
};
